// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"07ff1256","239":"eab0352a","453":"258b012d","553":"9194b18b","977":"37d9e8f3"}[chunkId] + ".chunk.js";
};